import React from 'react';
import PropTypes from 'prop-types';

const VariantStockIndicator = ({
  isInStock,
  isGiftCard,
  quantityAvailable,
}) => {
  if (!isInStock) return <>{' - SOLD OUT'}</>;
  if (quantityAvailable >= 10 || isGiftCard) return null;
  return (
    <span style={{ color: '#525252' }}>
      { quantityAvailable < 5
        ? ` - ${quantityAvailable} Item${quantityAvailable > 1 ? 's' : ''} Left`
        : ' - Low Stock'}
    </span>
  );
};

VariantStockIndicator.propTypes = {
  isInStock: PropTypes.bool,
  isGiftCard: PropTypes.bool,
  quantityAvailable: PropTypes.number,
};

export { VariantStockIndicator };
